import './legal.scss';
import { initNavbar, initFooterYear } from '@/ui';
import { initPostHog } from '@/services/posthog';

// Covers terms, privacy and refund — they are one entry now, so this is the
// single init the three separate page scripts used to do each for themselves.
initPostHog();

function boot(): void {
  initNavbar();
  initFooterYear();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
